import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Button from '../../shared/button.component';
import PeriodDropdown from '../../shared/periodDropdown.component';
import SecondaryMenu from '../../menu/secondaryMenu.component';
import AgGrid from '../../shared/agGrid/agGrid.component';
import { renderDate } from '../../shared/dateHelpers';
import { selectPeriod } from '../../shared/store/actions';
import { periodOrCurrentSelector, periodsSelector } from '../../shared/store/selectors';

import { fetchConnectionMonitorData } from '../store/actions';

import { defaultColumnDefs, connectionMonitorPageColumnDefs } from '../../shared/columnDefinitions/connectionMonitorPage';

class ConnectionMonitorPage extends PureComponent {
  static propTypes = {
    connectionsMonitorData: PropTypes.arrayOf(PropTypes.shape({
      connectionName: PropTypes.string,
      connectionErpName: PropTypes.string,
      lastRunDate: PropTypes.string,
      nextRunDate: PropTypes.string,
      scheduleStatus: PropTypes.number,
      heartbeatStatus: PropTypes.number,
    })).isRequired,
    connectionsMonitorDataLoading: PropTypes.bool.isRequired,
    connectionsMonitorUpdateTime: PropTypes.number,
    period: PropTypes.shape({
      name: PropTypes.string.isRequired,
      taxYear: PropTypes.string.isRequired,
    }).isRequired,
    periods: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      taxYear: PropTypes.string.isRequired,
    })),
    fetchConnectionMonitorData: PropTypes.func.isRequired,
    selectPeriod: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { period, fetchConnectionMonitorData } = this.props;

    fetchConnectionMonitorData(period);
  }

  refreshData = () => {
    const { period, fetchConnectionMonitorData } = this.props;

    fetchConnectionMonitorData(period);
  };

  selectPeriod = selectedPeriod => {
    const { periods, fetchConnectionMonitorData, selectPeriod } = this.props;

    const period = periods.find(period => period.name === selectedPeriod.value);

    selectPeriod(period);
    fetchConnectionMonitorData(period);
  };

  render() {
    const {
      connectionsMonitorData,
      connectionsMonitorDataLoading,
      connectionsMonitorUpdateTime,
    } = this.props;

    const lastUpdateTime = connectionsMonitorUpdateTime
      ? renderDate(connectionsMonitorUpdateTime)
      : null;

    return (
      <div className="connection-monitor-page">
        <SecondaryMenu>
          <PeriodDropdown
            onChange={this.selectPeriod}
          />
        </SecondaryMenu>
        <div className="page">
          <div className="container-fluid ">
            <div className="row no-gutters page-content-container">
              <div className="col">
                <div className="d-flex flex-row justify-content-between">
                  <h5>Connection Health</h5>
                  <span>
                    Updated: {lastUpdateTime}
                    {' '}
                    <Button
                      type="button"
                      kind="primary"
                      onClick={this.refreshData}
                    >
                      Refresh
                    </Button>
                  </span>
                </div>
              </div>
            </div>
            <div className="row no-gutters page-content-container">
              <div className="col">
                <AgGrid
                  columnDefs={connectionMonitorPageColumnDefs}
                  defaultColDef={defaultColumnDefs}
                  rowData={connectionsMonitorData}
                  isGridLoading={connectionsMonitorDataLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ dashboard, ...state }) => ({
  period: periodOrCurrentSelector(state),
  periods: periodsSelector(state),
  connectionsMonitorData: dashboard.connectionRunStatus.connectionsMonitorData,
  connectionsMonitorDataLoading: dashboard.connectionRunStatus.connectionsMonitorDataLoading,
  connectionsMonitorUpdateTime: dashboard.connectionRunStatus.connectionsMonitorUpdateTime,
});


export default connect(
  mapStateToProps,
  {
    fetchConnectionMonitorData,
    selectPeriod,
  }
)(ConnectionMonitorPage);
